import { parse } from "date-fns"
import { Time } from "../Helper/Time"
import { WeekType } from "../Helper/Week"
import { CustomerDetailInterface } from "./Customer"

export interface LessonTeacher {
    teacher_id: number
    ctm_id: number
    create_at: Date | null
    delete_at: Date | null
    customerData?: CustomerDetailInterface
}

export interface LessonStudent {
    student_id: number
    ctm_id: number
    create_at: Date | null
    delete_at: Date | null
    customerData?: CustomerDetailInterface
}

export interface LessonReservable {
    lrvable_id: number
    teacher_id: number
    week_conditions: WeekType
    start: Time
    end: Time
    start_apply: Date | null
    end_apply: Date | null
}
export interface ObjectToLessonReservableProps {
    lrvable_id: number
    teacher_id: number
    week_conditions: string
    start: string
    end: string
    start_apply: string
    end_apply: string
}
export const ObjectToLessonReservable = ({
    lrvable_id,
    teacher_id,
    week_conditions,
    start,
    end,
    start_apply,
    end_apply,
}: ObjectToLessonReservableProps): LessonReservable => {
    return {
        lrvable_id: lrvable_id,
        teacher_id: teacher_id,
        week_conditions: week_conditions as WeekType,
        start: new Time(start),
        end: new Time(end),
        start_apply: start_apply ? parse(start_apply, 'yyyy-MM-dd', new Date()) : null,
        end_apply: end_apply ? parse(end_apply, 'yyyy-MM-dd', new Date()) : null,
    }
}

export interface LessonUnreservable {
    lurvable_id: number
    teacher_id: number
    lurvable_date: Date
    start: Time | null
    end: Time | null
}
export interface ObjectToLessonUnreservableProps {
    lurvable_id: number
    teacher_id: number
    lurvable_date: string
    start: string | null
    end: string | null
}
export const ObjectToLessonUnreservable = ({
    lurvable_id,
    teacher_id,
    lurvable_date,
    start,
    end,
}: ObjectToLessonUnreservableProps): LessonUnreservable => {
    return {
        lurvable_id: lurvable_id,
        teacher_id: teacher_id,
        lurvable_date: parse(lurvable_date, 'yyyy-MM-dd', new Date()),
        start: start ? new Time(start) : null,
        end: end ? new Time(end) : null,
    }
}

export interface LessonStudio {
    lstd_id: number
    std_id: number
    std_name: string
    std_area?: string
    str_id: number
    str_name: string
    start_apply?: Date
    end_apply?: Date
    create_at?: Date
    delete_at?: Date
}
export interface ObjectToLessonStudioProps {
    lstd_id: number
    std_id: number
    std_name: string
    std_area?: string
    str_id: number
    str_name: string
    start_apply?: string
    end_apply?: string
    create_at?: string
    delete_at?: string
}
export const ObjectToLessonStudio = ({
    lstd_id,
    std_id,
    std_name,
    std_area,
    str_id,
    str_name,
    start_apply,
    end_apply,
    create_at,
    delete_at,
}: ObjectToLessonStudioProps): LessonStudio => {
    return {
        lstd_id: lstd_id,
        std_id: std_id,
        std_name: std_name,
        std_area: std_area,
        str_id: str_id,
        str_name: str_name,
        start_apply: start_apply ? parse(start_apply, 'yyyy-MM-dd', new Date()) : undefined,
        end_apply: end_apply ? parse(end_apply, 'yyyy-MM-dd', new Date()) : undefined,
        create_at: create_at ? new Date(create_at) : undefined,
        delete_at: delete_at ? new Date(delete_at) : undefined,
    }
}